module.exports = __webpack_public_path__ + "media/images/icons/vertical-align-center-80bba995d40d0caf497fee78fe3e30fb.svg";